// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-scroll-component {
  position: relative;
}

.notification-head {
  border-radius: 6px 6px 0 0;
  line-height: 24px;
}
.notification-head .material-icons {
  float: right;
  color: inherit;
}

.maintain-height .infinite-scroll-component {
  border-radius: 6px;
}
@media (max-width: 959px) {
  .maintain-height .infinite-scroll-component {
    border-radius: 0;
  }
}

.notification-head {
  padding: 10px;
  margin: 0;
}

.infinite-scroll-component .notification-head {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  margin: 0;
  bottom: auto;
  z-index: 9;
}

.inverted {
  transform: scaleY(-1);
}

.infinite-scroll-component .event-list-row {
  padding: 8px 10px;
}
.infinite-scroll-component .event-list-row .event-title {
  display: block;
  font-size: 14px;
  line-height: 1.5;
  flex: 1 1;
  font-weight: bold;
}
.infinite-scroll-component .event-list-row .event-name {
  opacity: 0.8;
  display: block;
  font-size: 12px;
  line-height: 1.5;
  flex: 1 1;
}
.infinite-scroll-component .event-list-row .event-date {
  font-size: 10px;
  opacity: 0.4;
}

.notification-bar {
  position: absolute;
  width: 260px;
  top: 53px;
  z-index: 9998;
  left: 390px;
  overflow: hidden;
}

.card-content {
  min-width: 300px;
}

.event-detail-date {
  text-align: right;
}

/* .detailsDiv .detail-right-section {
	//position: absolute;
	//right: 30px;
	//top: 50%;
	//margin-top: -16px;
} */
.event-detail-empty-heading {
  padding-top: 5px;
}

.event-detail-heading {
  font-size: 16px !important;
  line-height: 36px !important;
}

/* .detailsDiv .event-detail-address {
	margin-right: 200px;
} */
.infinite-scroll-component > p {
  font-weight: bold;
  margin: 0;
  padding: 10px 15px;
  /* position: absolute;
  left: 0;
  right: 0;
  bottom: 0; */
}

@media (max-width: 959px) {
  .detailsDiv .detail-right-section {
    margin-top: -35px;
    top: 100%;
    right: 15px;
  }
  .detailsDiv .detail-right-section img {
    float: left;
    width: 24px;
    height: auto;
  }
  .detailsDiv .detail-right-section {
    /* span {
    	//display: block;
    } */
  }
  .detailsDiv .event-detail-address {
    margin-right: 0;
  }
}
@media (max-width: 767px) {
  .event-detail-date {
    display: none;
  }
  .detail-right-section {
    display: none;
  }
  .event-detail-address {
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block; */
    display: none;
  }
  .event-detail-heading {
    font-size: 14px;
    font-weight: bold;
  }
  .event-detail-driver {
    float: right;
    padding-top: 1px;
    color: #666;
  }
  .notification-scroller {
    height: calc(100vh - 50px - 0);
    overflow-y: scroll;
  }
  .notification-bar {
    position: absolute;
    width: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .notification-bar.shown .infinite-scroll-component {
    max-height: calc(100vh - 50px - 0);
  }
  .infinite-scroll-component > p {
    padding: 10px 15px 5px;
  }
  .card-content {
    padding: 7px 16px !important;
  }
  .event-detail-empty-heading {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Events/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EAEC,kBAAA;AAFD;;AAKA;EACC,0BAAA;EACA,iBAAA;AAFD;AAGC;EACC,YAAA;EACA,cAAA;AADF;;AAKA;EAGC,kBAAA;AAJD;AAKC;EAJD;IAKE,gBAAA;EAFA;AACF;;AAKA;EACC,aAAA;EACA,SAAA;AAFD;;AAKA;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAFD;;AAIA;EACC,qBAAA;AADD;;AAGA;EACC,iBAAA;AAAD;AACC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AACF;AAEC;EACC,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAAF;AAEC;EACC,eAAA;EACA,YAAA;AAAF;;AAOA;EACC,kBAAA;EACA,YAAA;EACA,SC7CQ;ED8CR,aAAA;EACA,WAAA;EACA,gBAAA;AAJD;;AAMA;EACC,gBAAA;AAHD;;AAKA;EACC,iBAAA;AAFD;;AAKA;;;;;GAAA;AAMA;EACC,gBAAA;AAFD;;AAIA;EACC,0BAAA;EACA,4BAAA;AADD;;AAGA;;GAAA;AAGA;EACC,iBAAA;EACA,SAAA;EACA,kBAAA;EACA;;;cAAA;AAGD;;AAGA;EACC;IAEC,iBAAA;IACA,SAAA;IACA,WAAA;EADA;EAEA;IACC,WAAA;IACA,WAAA;IACA,YAAA;EAAD;EARD;IAUC;;OAAA;EAGA;EACD;IACC,eAAA;EACA;AACF;AACA;EACC;IACC,aAAA;EACA;EACD;IACC,aAAA;EACA;EACD;IACC;;;qBAAA;IAIA,aAAA;EACA;EACD;IACC,eAAA;IACA,iBAAA;EACA;EACD;IACC,YAAA;IACA,gBAAA;IACA,WAAA;EACA;EACD;IACC,8BAAA;IACA,kBAAA;EACA;EACD;IACC,kBAAA;IACA,WAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;EACA;EACC;IACC,kCAAA;EACF;EAGD;IACC,sBAAA;EADA;EAGD;IACC,4BAAA;EADA;EAGD;IACC,UAAA;EADA;AACF","sourcesContent":["@import \"../../assets/variables\";\n\n.infinite-scroll-component {\n\t//height: auto !important;\n\tposition: relative;\n}\n\n.notification-head  {\n\tborder-radius: 6px 6px 0 0;\n\tline-height: 24px;\n\t.material-icons {\n\t\tfloat: right;\n\t\tcolor: inherit;\n\t}\t\n}\n\n.maintain-height\n.infinite-scroll-component {\n\t// padding-top: 45px;\n\tborder-radius: 6px;\n\t@media (max-width: 959px) {\n\t\tborder-radius: 0;\n\t}\n}\n\n.notification-head {\n\tpadding: 10px;\n\tmargin: 0;\n}\n\n.infinite-scroll-component  .notification-head {\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\ttop: 0;\n\tmargin: 0;\n\tbottom: auto;\n\tz-index: 9;\n}\n.inverted {\n\ttransform: scaleY(-1);\n  }\n.infinite-scroll-component .event-list-row {\n\tpadding: 8px 10px;\n\t.event-title {\n\t\tdisplay: block;\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t\tflex: 1;\n\t\tfont-weight: bold;\n\n\t}\n\t.event-name {\n\t\topacity: 0.8;\n\t\tdisplay: block;\n\t\tfont-size: 12px;\n\t\tline-height: 1.5;\n\t\tflex: 1;\n\t}\n\t.event-date {\n\t\tfont-size: 10px;\n\t\topacity: 0.4;\n\t}\n}\n\n\n\n\n.notification-bar {\n\tposition: absolute;\n\twidth: 260px;\n\ttop: $topGap;\n\tz-index: 9998;\n\tleft: $sidebarWidth + 70px;\n\toverflow: hidden;\n}\n.card-content {\n\tmin-width: 300px;\n}\n.event-detail-date {\n\ttext-align: right;\n}\n\n/* .detailsDiv .detail-right-section {\n\t//position: absolute;\n\t//right: 30px;\n\t//top: 50%;\n\t//margin-top: -16px;\n} */\n.event-detail-empty-heading {\n\tpadding-top: 5px;\n}\n.event-detail-heading {\n\tfont-size: 16px !important;\n\tline-height: 36px !important;\n}\n/* .detailsDiv .event-detail-address {\n\tmargin-right: 200px;\n} */\n.infinite-scroll-component  > p {\n\tfont-weight: bold;\n\tmargin: 0;\n\tpadding: 10px 15px;\n\t/* position: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0; */\n}\n\n@media (max-width: 959px) {\n\t.detailsDiv .detail-right-section {\n\t\t//width: 150px;\n\t\tmargin-top: -35px;\n\t\ttop: 100%;\n\t\tright: 15px;\n\t\timg {\n\t\t\tfloat: left;\n\t\t\twidth: 24px;\n\t\t\theight: auto;\n\t\t}\n\t\t/* span {\n\t\t\t//display: block;\n\t\t} */\n\t}\n\t.detailsDiv .event-detail-address {\n\t\tmargin-right: 0;\n\t}\n}\n@media (max-width: 767px) {\n\t.event-detail-date {\n\t\tdisplay: none;\n\t}\n\t.detail-right-section {\n\t\tdisplay: none;\n\t}\n\t.event-detail-address {\n\t\t/* white-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: block; */\n\t\tdisplay: none;\n\t}\n\t.event-detail-heading {\n\t\tfont-size: 14px;\n\t\tfont-weight: bold;\n\t}\n\t.event-detail-driver {\n\t\tfloat: right;\n\t\tpadding-top: 1px;\n\t\tcolor: #666;\n\t}\n\t.notification-scroller {\n\t\theight: calc(100vh - #{$logoSectionHeight} - #{$footerHeight});\n\t\toverflow-y: scroll;\n\t}\n\t.notification-bar {\n\t\tposition: absolute;\n\t\twidth: auto;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\t&.shown {\n\t\t\t.infinite-scroll-component {\n\t\t\t\tmax-height: calc(100vh - #{$headerHeight} - #{$footerHeight});\n\t\t\t}\n\t\t}\n\t}\n\t.infinite-scroll-component > p {\n\t\tpadding: 10px 15px 5px;\n\t}\n\t.card-content {\n\t\tpadding: 7px 16px !important;\n\t}\n\t.event-detail-empty-heading {\n\t\tpadding: 0;\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
